<template>
  <div class="card-206 col-12">
    <div class="p-4 row align-content-center justify-content-center">
      <div class="text-center">
        <m-img class="mb-2 card-206-image" :src="image" :alt="alt"/>
        <h4 class="mb-3">
          <slot name="p-1">
            ارسال اکسپرس
          </slot>
        </h4>
        <p class="">
          <slot name="p-2">
            ارسال مستقیم از بانه
          </slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import mA from "../Tags/A";
import mImg from "../Tags/Img";
import {CardProps} from "./CardProps";

export default {
  name: "Card206",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
};
</script>

<style scoped>
.card-206 {
  border-radius: 18px;
  height: 250px;
  background: #f8f9fa;
}

.card-206-image {
  object-fit: contain;
  height: 95px;
  width: 95px;
}
</style>
